import * as React from "react"
import AdvertPeriodPicker from "../../../../utils/period_picker/AdvertPeriodPicker";
import RoomPeriodPicker from '../../../../utils/period_picker/RoomPeriodPicker'
import { StartEnd } from "../../../../utils/period_picker/PeriodPicker";
import { FocusedInputShape } from "react-dates";
import { Moment } from "moment";
import { RentalAdvert } from "../../../../types/types";

type Props = {
  advert: RentalAdvert
  arrival_date: Moment
  departure_date: Moment
  max_people_select: number
  max_people: number
  focusedInput: FocusedInputShape
  onDatesChange: (_: StartEnd) => void
  onFocusedInputChange: (_:FocusedInputShape) => void
  onMaxPersonsChange: (_:number) => void
  room_id: number
}


const getOptions = (max: number) : JSX.Element[] => {
  let options : JSX.Element[] = []
  for(let i = 1; i <= max; i++) {
    options.push(<option key={`people_${i}`} value={i}>{I18n.t('search.persons_count', { count: i})}</option>)
  }
  return options;
}

export default (props: Props) => (
  <>
    <div className='date-pickers form-row'>
      <div className='form-cell'>
        {
          props.room_id ?
            <RoomPeriodPicker
              startDate={props.arrival_date}
              endDate={props.departure_date}
              onDatesChange={(range: StartEnd) => props.onDatesChange(range)}
              room_id={props.room_id}
              onFocusChange={(fi) => props.onFocusedInputChange(fi)}
              focusedInput={props.focusedInput}
              close={() => null}
            />
          :
            <AdvertPeriodPicker
              startDate={props.arrival_date}
              endDate={props.departure_date}
              advert_id={props.advert.id}
              onDatesChange={(range: StartEnd) => props.onDatesChange(range)}
              onFocusChange={(fi) => props.onFocusedInputChange(fi)}
              focusedInput={props.focusedInput}
              close={() => null}
            />
        }
      </div>
    </div>
    <div className='form-row'>
        <div className='form-cell'>
          <select
            value={props.max_people || ''}
            onChange={(e) => props.onMaxPersonsChange(parseInt(e.target.value))}
          >
            {getOptions(props.max_people_select)}
          </select>
        </div>
    </div>
  </>
)


